import React, { useState } from 'react';
import { BREAKPOINTS } from '../../../constants';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import Drawer from '../../ui-components/Drawer/Drawer';
import { Modal } from './Modal';
import Typography, {
  TypographyVariants,
  TypographyWeights,
} from '../../ui-components/Typography/Typography';
import BetaIcon, { IconColors, IconSizes } from '../Icons/Icon';
import endpoints from '../../define/endpoints';

const B2BInfo = ({ type }) => {
  const isDeviceSmallerThanTablet = !useMatchesMinWidth(BREAKPOINTS.TABLET);
  const [containerIsOpen, setContainerIsOpen] = useState(false);
  const mainTitle =
    type === 'format-type' ? 'Scopri le differenze' : 'Codice di riferimento';
  const physicalFormat = (
    <>
      <p>
        Se scegli di acquistare un <b>voucher fisico</b>, riceverai una lettera
        in formato A4 con i dettagli relativi all’attività desiderata, stampata
        e riposta in una busta brandizzata Freedome.
      </p>
      <p>
        Se invece opti per una <b>gift card fisica</b>, riceverai una tessera in
        pvc accompagnata da una lettera in formato A4, riposta in una busta
        brandizzata Freedome.
      </p>
    </>
  );
  const digitalFormat = (
    <>
      <p>
        Nel caso tu decida di acquistare un <b>voucher digitale</b>, riceverai
        un pdf con i dettagli relativi all’attività scelta, tramite posta
        elettronica.
      </p>
      <p>
        Se invece scegli una <b>gift card digitale</b>, riceverai via posta
        elettronica un pdf contenente i dettagli relativi alla gift card.
      </p>
    </>
  );

  const mobileImage = (
    <img
      src={`${endpoints.bucket}images/b2b/reference-code-mobile.png`}
      class="margin-bottom--4"
    />
  );
  const desktopImage = (
    <img
      src={`${endpoints.bucket}images/b2b/reference-code-desktop.png`}
      class="margin-bottom--4"
    />
  );

  const formatContent = (
    <>
      <div className="pt-xl pr-3xl pl-3xl d-flex flex-wrap">
        <div
          className="ml-s"
          style={{ maxWidth: isDeviceSmallerThanTablet ? '100%' : '45%' }}
        >
          <div className="section-header pb-3xs">
            <b class="d-flex items-center mr-base">
              <span
                class="iconify inline iconify__big mr-base"
                data-icon="mdi:gift-outline"
              ></span>
              Formato fisico
            </b>
          </div>
          <div className="section-content text-left ml-s">{physicalFormat}</div>
        </div>

        <div
          className="ml-s"
          style={{ maxWidth: isDeviceSmallerThanTablet ? '100%' : '45%' }}
        >
          <div className="section-header pb-3xs">
            <b class="d-flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="mr-base"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M5.33333 11.9999H10.6667V10.6666H5.33333V11.9999ZM5.33333 9.33325H10.6667V7.99992H5.33333V9.33325ZM4 14.6666C3.63333 14.6666 3.31944 14.536 3.05833 14.2749C2.79722 14.0138 2.66667 13.6999 2.66667 13.3333V2.66659C2.66667 2.29992 2.79722 1.98603 3.05833 1.72492C3.31944 1.46381 3.63333 1.33325 4 1.33325H9.33333L13.3333 5.33325V13.3333C13.3333 13.6999 13.2028 14.0138 12.9417 14.2749C12.6806 14.536 12.3667 14.6666 12 14.6666H4ZM8.66667 5.99992V2.66659H4V13.3333H12V5.99992H8.66667Z"
                  fill="#181f36"
                />
              </svg>
              Formato digitale (pdf)
            </b>
          </div>
          <div className="section-content text-left ml-s">{digitalFormat}</div>
        </div>
      </div>
      <div className="pt-xl pb-3xl pr-3xl pl-3xl">
        <div
          className="p-xs"
          style={{ background: '#e5e9ee', borderRadius: '8px' }}
        >
          *In base al formato scelto, il prezzo e le tempistiche di ricezione
          potrebbero variare.
        </div>
      </div>
    </>
  );

  const referralContent = (
    <div className="pt-xl pr-3xl pl-3xl">
      <p>
        Il codice di riferimento si trova in fondo alla pagina dell’esperienza,
        sotto le recensioni
      </p>
      {isDeviceSmallerThanTablet ? mobileImage : desktopImage}
    </div>
  );

  const infoContainer = isDeviceSmallerThanTablet ? (
    <Drawer
      isOpen={containerIsOpen}
      onClose={() => setContainerIsOpen(false)}
      title={mainTitle}
      body={
        <div> {type === 'format-type' ? formatContent : referralContent}</div>
      }
    />
  ) : (
    <Modal
      onClickOverlay={() => setContainerIsOpen(false)}
      isOpen={containerIsOpen}
      shouldScroll={false}
    >
      <div className="d-flex flex-column" style={{ width: '964px' }}>
        <div>
          <div className="modal-response__header">
            <div className="modal-response__header__close-btn">
              <button
                className="pointer"
                onClick={() => setContainerIsOpen(false)}
              >
                <BetaIcon
                  name={'close'}
                  size={IconSizes[12]}
                  color={IconColors.regular}
                />
              </button>
            </div>
            <Typography
              variant={TypographyVariants.h6}
              weight={TypographyWeights['semi-bold']}
            >
              {mainTitle}
            </Typography>
          </div>
          {type === 'format-type' ? formatContent : referralContent}
        </div>
      </div>
    </Modal>
  );

  return (
    <React.Fragment>
      {infoContainer}
      <p>
        Disponibili in formato fisico e digitale{' '}
        <a onClick={() => setContainerIsOpen(true)}>(vedi dettagli formato)</a>
      </p>
    </React.Fragment>
  );
};

B2BInfo.propTypes = {};

B2BInfo.defaultProps = {};

export default B2BInfo;
